import script from "./LoginTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginTemplate.vue?vue&type=script&setup=true&lang=js"

import "./LoginTemplate.vue?vue&type=style&index=0&id=1d1d55fc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ignis-front-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d1d55fc"]])

export default __exports__